<template>
  <v-dialog transition="dialog-top-transition" v-model="showPopper" fullscreen>
    <v-card class="popper">
      <div class="header">
        {{ headerTitle }}
        <v-btn class="exit-btn" @click="close" icon="mdi-close"> </v-btn>
      </div>
      <component
        v-bind:is="component.bind.is"
        v-bind="component.bind"
        v-on="component.on"
      />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Popper",
  props: {
    component: {
      type: Object,
      required: true,
    },
    headerTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showPopper: false,
    };
  },
  created() {
    this.showPopper = true;
  },
  methods: {
    close() {
      this.emitter.emit("closePopper");
    },
  },
};
</script>

<style lang="scss" scoped>
.popper {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    background-color: transparent;
    font-size: 32px;
    color: #000;
    min-height: 64px;
    margin-bottom: 24px;
    box-shadow: rgba(11, 81, 124, 0.2) 0px 3px 6px 0px;
    .exit-btn {
      background-color: #c70404;
      color: #fff;
    }
  }
}
</style>
